import React, { FC } from 'react';

import { Button, List } from '$uikit';
import { useTranslator } from '$hooks';
import { IcBankCard28, IcMir56 } from '$assets';
import {
  PaymentMethodOption,
  PaymentProviderConfig,
  PayProvider,
} from '$store/pay/interface';

type Props = {
  countryCode: string;
  onSelect: (config: PaymentProviderConfig) => void;
};

export const TesterPaymentMethods: FC<Props> = ({ countryCode, onSelect }) => {
  const t = useTranslator();

  const buttons: {
    label: string;
    icon: React.ReactNode;
    config: PaymentProviderConfig;
  }[] = [
    {
      label: 'Tribute',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.tribute,
        paymentMethod: PaymentMethodOption.CARD,
        countryCode,
      },
    },
    {
      label: 'PayItNow24',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.payitnow24,
        paymentMethod: PaymentMethodOption.CARD,
        countryCode,
      },
    },
    {
      label: 'PayItNow24 PayPal',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.payitnow24,
        paymentMethod: PaymentMethodOption.PAYPAL,
        countryCode,
      },
    },
    {
      label: `1Payment ${t('top_up_method_sbp')}`,
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.onePayment,
        paymentMethod: PaymentMethodOption.SBP,
        countryCode,
      },
    },
    {
      label: `Plategaio ${t('top_up_method_sbp')}`,
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.plategaio,
        paymentMethod: PaymentMethodOption.SBP,
        countryCode,
      },
    },
    {
      label: `OnlyPay ${t('top_up_method_sbp')}`,
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.only,
        paymentMethod: PaymentMethodOption.SBP,
        countryCode,
      },
    },
    {
      label: 'M3 Мир',
      icon: <IcMir56 />,
      config: {
        provider: PayProvider.m3,
        paymentMethod: PaymentMethodOption.CARD_ACQUIRING,
        countryCode,
      },
    },
    {
      label: 'Inwizo МИР',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.inwizo,
        paymentMethod: PaymentMethodOption.CARD_ACQUIRING,
        countryCode,
      },
    },
    {
      label: 'Inwizo SBP',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.inwizo,
        paymentMethod: PaymentMethodOption.SBP,
        countryCode,
      },
    },
    {
      label: `HighHelp ${t('top_up_method_sbp')}`,
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.highhelp,
        paymentMethod: PaymentMethodOption.SBP,
        countryCode,
      },
    },
    {
      label: `Hodler ${t('top_up_method_sbp')}`,
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.hodler,
        paymentMethod: PaymentMethodOption.SBP,
        countryCode,
      },
    },
    {
      label: 'PayBall Card',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.payball,
        paymentMethod: PaymentMethodOption.CARD,
        countryCode,
      },
    },
    {
      label: 'PayBall Apple Pay',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.payball,
        paymentMethod: PaymentMethodOption.APPLE_PAY,
        countryCode,
      },
    },
    {
      label: 'PayBall Google Pay',
      icon: <IcBankCard28 />,
      config: {
        provider: PayProvider.payball,
        paymentMethod: PaymentMethodOption.GOOGLE_PAY,
        countryCode,
      },
    },
  ];

  return (
    <List title="For tester">
      <div className="TopUpBalanceSheet__methods">
        {buttons.map((btn) => (
          <Button
            key={btn.label}
            onClick={() => onSelect(btn.config)}
            icon={btn.icon}
            mode="pay"
          >
            {btn.label}
          </Button>
        ))}
      </div>
    </List>
  );
};
